// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","549":"4bb29022","781":"f1664b03","976":"d3c98862"}[chunkId] + ".chunk.js";
};